import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable, catchError, of, tap } from 'rxjs';
import { environment } from 'src/environments/environment.development';
import { User } from '../entities/user';
import { isPlatformBrowser } from '@angular/common';

interface LoginResponse {
  status: string;
  data?: User;
  message?: string;
  token?: string;
}

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      this.authBS = new BehaviorSubject<string>(String(sessionStorage.getItem('auth')));
      this.loggedUserBS = new BehaviorSubject<string>(String(sessionStorage.getItem('loggedUser')));
    }
   }

  private apiServicesUrl = environment.cfgApiBaseUrl;
  authBS: BehaviorSubject<string> = new BehaviorSubject<string>('');
  loggedUserBS: BehaviorSubject<string> = new BehaviorSubject<string>('');

  login(user: string, password: string): Observable<LoginResponse> {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }
    return this.http.post<LoginResponse>(this.apiServicesUrl + '/auth', {'userName': user,'password': password}, httpHeaders)
    .pipe(
      tap( (loginData) => {
        if (loginData.token) {
          this.authBS.next(loginData.token!);
          let loggedUser: string;
          loggedUser = loginData.data?.userName!;
          if (loginData.data?.role === 'administrador')
            loggedUser = 'admin';
          this.loggedUserBS.next(loggedUser);
        }
      }),
      catchError(this.handleError<LoginResponse>('login'))
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  get auth(): Observable<string> {
    return this.authBS.asObservable();
  }
  
  get loggedUser(): Observable<string> {
    return this.loggedUserBS.asObservable();
  }

  isLogged(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      return sessionStorage.getItem('auth') != null;
    } else {
      return false;
    }
  }

  isAdminLogged(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      return sessionStorage.getItem('loggedUser') != null && sessionStorage.getItem('loggedUser') === 'admin';
    } else {
      return false;
    }
  }
    
}
